const BTC_FRACTION_DIGITS = 10;
const DECIMAL_RE = /^([+-]?)(\d*)(?:\.(\d*))?$/u;

const roundDecimalString = (value: string, fractionDigits: number) => {
  const normalized = value.trim().replace(',', '.');
  const match = normalized.match(DECIMAL_RE);
  if (!match) return normalized;

  const sign = match[1];
  const integerPart = match[2] || '0';
  const fractionPart = match[3] || '';
  if (fractionPart.length <= fractionDigits) {
    return fractionPart ? `${sign}${integerPart}.${fractionPart}` : `${sign}${integerPart}`;
  }

  const keptFraction = fractionPart.slice(0, fractionDigits);
  const nextDigit = fractionPart[fractionDigits];
  const digits = `${integerPart}${keptFraction.padEnd(fractionDigits, '0')}`.split('');

  if (nextDigit >= '5') {
    let carry = 1;
    for (let index = digits.length - 1; index >= 0 && carry; index -= 1) {
      const next = Number(digits[index]) + carry;
      digits[index] = String(next % 10);
      carry = next > 9 ? 1 : 0;
    }
    if (carry) digits.unshift('1');
  }

  const rounded = digits.join('').padStart(fractionDigits + 1, '0');
  const splitIndex = rounded.length - fractionDigits;
  return `${sign}${rounded.slice(0, splitIndex)}.${rounded.slice(splitIndex)}`;
};

export const formatBtc = (value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === '') return '0';
  const normalized = typeof value === 'number' ? value.toFixed(BTC_FRACTION_DIGITS) : roundDecimalString(String(value), BTC_FRACTION_DIGITS);
  const trimmed = normalized.replace(/(\.\d*?[1-9])0+$/u, '$1').replace(/\.0+$/u, '').replace(/\.$/u, '');
  return trimmed === '' ? '0' : trimmed;
};
